module.exports = __webpack_public_path__ + "static/media/831.f751e0ba.gif";